import GroupsBlock from "./GroupsBlock/GroupsBlock";
import { useTranslation } from "react-i18next";
import PageTitle from "../../components/common/PageTitle/PageTitle";
import { CircularIndeterminate } from "../../components/common/CircularIndeterminate";
import { useProcessingRequest } from "../../store/selectors/tableManagementSelector";

export default function GroupsPage() {
  const { t } = useTranslation();
  const processingRequest = useProcessingRequest()

  return (
    <>
      <PageTitle
        breadcrumbs={[]}
        title={t("groupsPage.groups.title")}
      />
      <GroupsBlock />

      <CircularIndeterminate processingRequest={processingRequest} />
    </>
  );
};
